import { LitElement, css, html } from 'lit'

export class DzPriceInput extends LitElement {
    static get properties() {
        return {
            price:      { type: Number, reflect: true },
            mode:       { type: String, state: true },
            min:        { type: Number },
            max:        { type: Number },         
            prefix:     { type: String },
            postfix:    { type: String }
        }
    }

    constructor() {
        super()
        this.mode = "display"
        this.postfix = ""
    }

    formatPrice(val, currency = "руб") {
        return Number(val).toLocaleString() + " " + currency
    }

    render() {
        if (this.mode == "display") {
            return html`<span @click="${() => this.mode = "input"}" part="display">${this.prefix} ${this.formatPrice(this.price, this.postfix)}</span>`
        } else {
            return html`<input @blur="${this.applyInput}" @change="${this.applyInput}" part="input"/>`
        }
    }

    updated() {
        if (this.mode == "input") {
            this.renderRoot.querySelector("input").focus()
        }
    }

    applyInput(evt) {
        let val = Number(evt.target.value)
        if (val && !isNaN(val)) {
            console.log("set value ", val)
            this.price = Math.min(this.max, Math.max(this.min, val))
            let evt = new CustomEvent("change", {bubbles: true, composed: true})
            this.dispatchEvent(evt)
        } 
        this.mode = "display"
    }
}

window.customElements.define('dz-price-input', DzPriceInput)